<template>
  <div class="comm_shut_wrap">
    <div class="inbox">
      <sui-jqx-grid
          :columns="gridColumns1" :dataset="'dataset1'"
          width="100%"  height="250px" :rowsheight="40" :scrollbarsize="0"
          :columnsresize="true" :columnsautoresize="false"/>
    </div>
    <div class="btnbox"><ul>
        <li><button class="comm_btn_shut_right">오른쪽보내기</button></li>
        <li><button class="comm_btn_shut_left">왼쪽보내기</button></li>
    </ul></div>
    <div class="inbox">
      <sui-jqx-grid
          :columns="gridColumns2" :dataset="'dataset2'"
          width="100%" height="250px" :rowsheight="40" :scrollbarsize="0"
          :columnsautoresize="true" :columnsresize="true"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {return {
    gridColumns1: [
      {datafield: 'datafield0', text: '컬럼01'},
      {datafield: 'datafield1', text: '타이틀이겁나길면어떻게들어가나봅시다'},
      {datafield: 'datafield2', text: '이만큼쓰면넘어가려나점이생기려나'},
      {datafield: 'datafield3', text: '일하기싫을때는 집에가자 먹고싶을땐 대지같이 먹자'}
    ],
    gridColumns2: [
      {datafield: 'datafield0', text: '제목'},
      {datafield: 'datafield1', text: '이름이길어지면 이게 맞는건가'},
      {datafield: 'datafield2', text: '공백'},
      {datafield: 'datafield3', text: '나도몰라'},
      {datafield: 'datafield4', text: '오늘할일은내일로'}
    ],
    localdata1: [
      ['11', '2', '3', '4'],
      ['12', '2', '3', '4'],
      ['13', '2', '3', '4'],
      ['14', '2', '3', '4'],
      ['15', '2', '3', '4'],
      ['16', '2', '3', '4'],
      ['17', '2', '3', '4'],
      ['18', '2', '3', '4'],
      ['19', '2', '3', '4'],
      ['10', '2', '3', '4'],
      ['21', '2', '3', '4'],
      ['22', '2', '3', '4'],
      ['23', '2', '3', '4'],
      ['24', '2', '3', '4'],
      ['25', '2', '3', '4']
    ],
    localdata2: [
      ['1', '로또1등 2번이나 당첨된 사람', '취미로 회사다니는 사람', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['취미로 회사다니는 사람', '22', '33', '가진게돈밖에 없는 사람', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55'],
      ['1', '2', '3', '4', '5'],
      ['11', '22', '33', '44', '55']
    ],
  }},
  datasets: [{
    id: 'dataset1', type: 'local', data: 'localdata1',
    datafields: [
      {name: 'datafield0',type: 'string',map: '0'},
      {name: 'datafield1',type: 'string',map: '1'},
      {name: 'datafield2',type: 'string',map: '2'},
      {name: 'datafield3',type: 'string',map: '3'}
    ]
  }, {
    id: 'dataset2',type: 'local',data: 'localdata2',
    datafields: [
      {name: 'datafield0',type: 'string',map: '0'},
      {name: 'datafield1',type: 'string',map: '1'},
      {name: 'datafield2',type: 'string',map: '2'},
      {name: 'datafield3',type: 'string',map: '3'},
      {name: 'datafield4',type: 'string',map: '4'}
    ]
  }]
}
</script>